import React, { useEffect } from "react";
import { FaSignOutAlt } from "react-icons/fa";
import "./LogoutConfirmModal.css";

function LogoutConfirmModal({
  isOpen,
  onCancel,
  onConfirm,
  title = "Sign Out",
  message = "Are you sure you want to sign out of your account?",
  confirmLabel = "Sign Out",
  cancelLabel = "Stay Signed In",
}) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onCancel();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="logout-modal-overlay" onClick={onCancel} role="presentation">
      <div
        className="logout-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="logout-modal-icon-wrap" aria-hidden="true">
          <FaSignOutAlt className="logout-modal-icon" />
        </div>

        <h3 id="logout-modal-title" className="logout-modal-title">
          {title}
        </h3>
        <p className="logout-modal-message">{message}</p>

        <div className="logout-modal-actions">
          <button
            type="button"
            className="logout-modal-btn logout-modal-btn-secondary"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="logout-modal-btn logout-modal-btn-primary"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogoutConfirmModal;
